module.exports = __webpack_public_path__ + "img/img_23@2x.57732602.png";